import PropTypes from 'prop-types'

export const startPageDataPropType = PropTypes.shape({
  link: PropTypes.string,
})
